
Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require('styled-components'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _templateObject() {
  var data = _taggedTemplateLiteral([
    '\n  padding: ',
    '\n  background: ',
    '}\n  border: ',
    '\n  border-radius: ',
    '\n  box-shadow: ',
    '\n'
  ]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var StyledCard = _styledComponents.default.div(
  _templateObject(),
  function (props) {
    return props.theme.card.padding;
  },
  function (props) {
    return props.theme.card.background.color;
  },
  function (props) {
    return ''
      .concat(props.theme.card.border.width, ' ')
      .concat(props.theme.card.border.style, ' ')
      .concat(props.theme.card.border.color);
  },
  function (props) {
    return props.theme.card.border.radius;
  },
  function (props) {
    return props.theme.card.boxShadow;
  }
);

exports.StyledCard = StyledCard;
